import { FlatActionList } from "@towersystems/roam-common-native";
import { Controller, useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { useTranslation } from "../../../../../../utilities/i18n";
import { InvoiceArrivalDetailsFormValues } from "../../types";
import { Switch } from "react-native";

export interface InvoiceIncGstFormInputProps {}

export const InvoiceIncGstFormInput = ({}: InvoiceIncGstFormInputProps) => {
  const { t } = useTranslation("invoice_arrival");
  const { control } = useFormContext<InvoiceArrivalDetailsFormValues>();
  return (
    <View>
      <FlatActionList
        items={[
          {
            key: "costPriceIncGST",
            title: t("form.invoice_cost_price_inc_gst.label"),
            subTitle: t("form.invoice_cost_price_inc_gst.description"),
            onPress: () => {},
            componentRight: () => (
              <Controller
                name="costPriceIncGST"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <View>
                    <Switch
                      value={value}
                      onValueChange={() => {
                        onChange(!value);
                      }}
                    />
                  </View>
                )}
              />
            ),
          },
        ]}
      />
    </View>
  );
};
